var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    ref: "input",
    staticClass: "form-control",
    class: _vm.className,
    attrs: {
      type: "number",
      name: _vm.name,
      placeholder: _vm.placeholder,
      disabled: _vm.disabled,
      tabindex: _vm.tabindex,
    },
    domProps: { value: _vm.value },
    on: {
      change: _vm.handleChange,
      focusout: _vm.handleFocusOut,
      keydown: _vm.onlyNumbers,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }